import styled from '@mui/material/styles/styled'
import TableCell from '@mui/material/TableCell'

export const RightCell = styled(TableCell, {
  name: 'RightCell',
  slot: 'Root',
  skipSx: true,
})`
  border: none;
  font-family: Source Sans Pro;
  padding: 0;
`
